import React from 'react';
import Navbar from '../components/Internal-nav';  
import './team.scss';
import KometsBanner from '../components/komets-banner';
  
function Team() {

const TeamMember = ({ name, role, imgPosition, imgSrc }) => (
    <div className={`image-${imgPosition.includes('right') ? 'right' : 'left'}`}>
        <div className='alt-image'>
            <img src={imgSrc} alt={name} />
        </div>
        <div className='alt-content'>
            <h2>{name}</h2>
            <p>{role}</p>
        </div>
    </div>
);

// Usage

    return (
      <div className='App'>
      <header>
        <Navbar />
      </header>
      <div>
        <div className='inner-banner' style={{ backgroundImage: "url(../assets/shop-photo-banner.jpg)"}}>
          <div className='banner-content'>
          <h1>Meet Our Team</h1>
          </div>
        </div>
            
            <div className='container'>
                <div className='team'>
                <TeamMember name="Marc Butler" role="Owner" imgPosition="left" imgSrc="../assets/profile-photos/marc_butler.jpg" />
                <TeamMember name="Jacob Chrzan" role="Owner" imgPosition="right" imgSrc="../assets/profile-photos/jake.jpg" />
                <TeamMember name="Dina Sljivo" role="Financial Controller" imgPosition="left" imgSrc="../assets/profile-photos/dina_sljivo.jpg" />
                <TeamMember name="Jeff Mayo" role="Fabrication Manager" imgPosition="right" imgSrc="../assets/profile-photos/jeff_mayo.jpg" />
                <TeamMember name="Craig Haver" role="Project Engineer" imgPosition="left" imgSrc="../assets/profile-photos/craig.jpg" />
                <TeamMember name="Nate Sullivan" role="Director of Pre-Construction" imgPosition="right" imgSrc="../assets/profile-photos/nate.jpg" />
                <TeamMember name="Ashley Fitzgerald" role="Project Manager" imgPosition="left" imgSrc="../assets/profile-photos/ashley.jpg" />
                <TeamMember name="Kurt Frederick" role="Project Specialist Flooring" imgPosition="right" imgSrc="../assets/profile-photos/kurt.jpg" />
                <TeamMember name="Logan Baumgartner" role="Project Manager" imgPosition="left" imgSrc="../assets/profile-photos/logan_baumgartner.jpg" />
                <TeamMember name="Diana Campos" role="Office/Procurement Manager" imgPosition="right" imgSrc="../assets/profile-photos/diana.jpg" />
                <TeamMember name="Robby Campos" role="Installation Specialist" imgPosition="left" imgSrc="../assets/profile-photos/robbie_campos.jpg" />
                <TeamMember name="Tyler Snyder" role="Fabrication Specialist" imgPosition="right" imgSrc="../assets/profile-photos/tyler_snyder.jpg" />
                </div>
            </div>
         </div>
         <KometsBanner></KometsBanner>
      </div>
    );
  };
  
export default Team;
